import { ClickAwayListener, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { okaidia } from 'react-syntax-highlighter/dist/esm/styles/prism';
import CopyToClipboard from 'react-copy-to-clipboard'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box } from '@mui/system';

export const SourceDialog = (props) => {
  const { htmlText, isOpen, closeDialog } = props
  const [copyText, setCopyText] = useState("Copy to Clipboard")
  const handleCopy = () => {
    setCopyText("Copied!")
    setTimeout(() => { setCopyText("Copy to Clipboard") }, 1000)
  }
  return (
    <Dialog
      open={isOpen}
      onClose={closeDialog}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle>
        {"Html Source"}
        <IconButton
          onClick={closeDialog}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ position: "relative" }}>
        <DialogContentText id="alert-dialog-description">
          <SyntaxHighlighter language="html" style={okaidia}>
            {htmlText}
          </SyntaxHighlighter>
        </DialogContentText>
        <Box sx={{ position: "absolute", top: "20px", right: "35px" }}>
          <CopyToClipboard
            text={htmlText}
            onCopy={handleCopy}
          >
            <Tooltip title={copyText} placement="top" arrow>
              <IconButton>
                <ContentCopyIcon sx={{ color: "rgb(248, 248, 242)" }} />
              </IconButton>
            </Tooltip>
          </CopyToClipboard>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
